import React, { useState } from "react";
import { Modal, Table, Space, Tag } from "antd";
import moment from "moment";
import InvoiceModal from "../../listFactura/components/InvoiceModal";

const VendedorFacturasModal = ({ visible, onClose, vendedor, fecha }) => {
  const [selectedFactura, setSelectedFactura] = useState(null);
  const [isInvoiceModalVisible, setIsInvoiceModalVisible] = useState(false);

  const calculateFacturaTotal = (factura) => {
    return (
      factura.productos?.reduce((acc, producto) => {
        const subtotal = producto.cantidad * producto.precio_unitario;
        const impuesto = producto.producto?.grupo?.impuesto || 0;
        const impuestoValue = subtotal * (impuesto / 100);
        return acc + (subtotal + impuestoValue);
      }, 0) || 0
    );
  };

  const columns = [
    {
      title: "Consecutivo",
      dataIndex: "consecutivo",
      render: (text, record) => (
        <a
          onClick={() => {
            setSelectedFactura(record);
            setIsInvoiceModalVisible(true);
          }}
        >
          #{text}
        </a>
      ),
    },
    {
      title: "Cliente",
      key: "cliente",
      render: (_, record) => (
        <span>
          {record.cliente?.first_name} {record.cliente?.last_name}
        </span>
      ),
    },
    {
      title: "Caja",
      key: "caja",
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <span>{record.caja?.nombre}</span>
          <Tag
            color={record.caja?.estado?.estado === "activa" ? "green" : "red"}
          >
            {record.caja?.estado?.estado}
          </Tag>
        </Space>
      ),
    },
    {
      title: "Total",
      key: "total",
      render: (_, record) =>
        `$${calculateFacturaTotal(record).toLocaleString()}`,
    },
    {
      title: "Estado",
      dataIndex: "estado",
      render: (estado, record) => (
        <Space direction="vertical" size="small">
          <Tag
            color={
              estado === "activa"
                ? "green"
                : estado === "devolución de factura"
                ? "red"
                : "gold"
            }
          >
            {estado}
          </Tag>
        </Space>
      ),
    },
  ];

  const activeFacturas =
    vendedor?.facturas?.filter(
      (factura) => factura.estado !== "devolución de factura"
    ) || [];

  return (
    <>
      <Modal
        title={`Facturas de ${vendedor?.first_name} ${vendedor?.last_name}`}
        open={visible}
        onCancel={onClose}
        width={1000}
        footer={null}
      >
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <div>
            <strong>Fecha:</strong> {moment(fecha).format("DD/MM/YYYY")}
          </div>
          <div>
            <strong>Supervisor:</strong> {vendedor?.superior?.first_name}{" "}
            {vendedor?.superior?.last_name}
          </div>
          <Table
            columns={columns}
            dataSource={activeFacturas}
            rowKey="id"
            pagination={false}
            scroll={{ y: 400 }}
          />
        </Space>
      </Modal>

      <InvoiceModal
        selectedFactura={selectedFactura}
        isModalVisible={isInvoiceModalVisible}
        setIsModalVisible={setIsInvoiceModalVisible}
        setSelectedFactura={setSelectedFactura}
     validation={false}
      />
    </>
  );
};

export default VendedorFacturasModal;
